import { create } from "zustand";

interface SidebarState {
  collapsed: boolean;
  toggle: () => void;
}

const getInitial = (): boolean => {
  try {
    return localStorage.getItem("cq-sidebar-collapsed") === "1";
  } catch {
    return false;
  }
};

export const useSidebarStore = create<SidebarState>((set) => ({
  collapsed: getInitial(),
  toggle: () =>
    set((s) => {
      const next = !s.collapsed;
      try {
        localStorage.setItem("cq-sidebar-collapsed", next ? "1" : "0");
      } catch {
        /* 무시 */
      }
      return { collapsed: next };
    }),
}));
